import globals from '../../common/globals';

export default {
  name: 'vx-campaign-program',
  data() {
    return {
      globals,
      showProgiframe: false,
      showProgImg: true,
    };
  },
  props: {
    theProgram: { type: Object },
  },
  methods: {
    openVideo() {
      const hgt = document.querySelector('.BTA-img').clientHeight;
      const progBody = document.querySelector('.BTA-prog-img');
      progBody.style = `height:${hgt}px`;

      this.showProgiframe = true;
      this.showProgImg = false;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/campaigns/vx-campaign-program/vx-campaign-program.js